export default __webpack_public_path__ + "static/media/mautic6.0a3d980a.svg";